export default __webpack_public_path__ + "static/media/sg-logo.0258d176.svg";